// extracted by mini-css-extract-plugin
export default {"transportation_funds_remaining_cell":"CurencyCell_transportation_funds_remaining_cell__3R5s-","full_height":"CurencyCell_full_height__MTMlX"};